import React, { FC } from 'react';

import { Box } from '@mui/system';

import { ContractTypes } from '@pharmaplan/common';

import useAddWorkshift from '../../../../hooks/workshift/useAddWorkshift';
import CustomTextField from '../../../common/CustomTextField';
import genericClasses from '../../../../theme/GenericClasses';
import { isIpad } from '../../../../helpers/Constants';
import AllowanceWorkshift from '../AllowanceWorkshift';
import NotesField from '../../../common/NotesField';
import strings from '../../../../localization';
import WorkshiftForm from '../WorkshiftForm';

import LongTermHourlyRates from './LongTermHourlyRates';
import classes from './styles';

/*
  ADD WORKSHIFT SCREEN FOR SELF-SERVICE
*/

interface IAdd {
  date: string;
}

const Add: FC<IAdd> = ({ date }) => {
  const { container } = classes;

  const { formik } = useAddWorkshift(date);
  const isShortTerm = formik.values.contractType === ContractTypes.shortTerm;
  const notesSx = isIpad ? classes.notes : {};

  return (
    <Box sx={container}>
      <WorkshiftForm customDateName="datePicker" formik={formik} isSeries />

      <LongTermHourlyRates formik={formik} />
      {isShortTerm && <AllowanceWorkshift formik={formik} />}

      {!isShortTerm && (
        <Box sx={notesSx}>
          <CustomTextField
            variant="outlined"
            formik={formik}
            placeholder={strings.allowancePlaceholder}
            id="notes"
            label={strings.allowances}
            name="allowanceNotes"
            multiline
            maxLength={200}
            customClass={genericClasses.borderNoneTextField}
          />
        </Box>
      )}

      <NotesField formik={formik} />
    </Box>
  );
};

export default Add;
